import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateAgent } from "@/api/agents";
import { AgentsQueryKeys } from "@/tanstackQuery/queries";

export const useUpdateAgent = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateAgent,
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: [AgentsQueryKeys.All],
      });
    },
  });
};
